import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { RouterModule } from "@angular/router";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { HeaderComponent } from "./components/header/header.component";
import { removeWhitespacePipe, SidebarComponent } from "./components/sidebar/sidebar.component";
import { LoginComponent } from "./components/login/login.component";
import { HomeComponent } from "./components/home/home.component";
import { LeadsComponent } from "./components/lead/leads.component";
import { NotAuthorizedComponent } from "./components/not-authorized/not-authorized.component";
import { ButtonModule } from "primeng/button";
import { InputTextModule } from "primeng/inputtext";
import { FormsModule } from "@angular/forms";
import { MessagesModule } from "primeng/messages";
import { MessageModule } from "primeng/message";
import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";
import { LoginService } from "./components/login/login.service";
import { provideAuth0 } from '@auth0/auth0-angular';
import { ToastModule } from "primeng/toast";
import { ClientComponent } from "./components/client/client.component";
import { TrainingComponent } from "./components/training/training.component";
// Import canActivate guards
import { AuthGuard } from "../app/components/guard/auth.guard";
import { SecureInnerPagesGuard } from "../app/components/guard/secure-inner-pages.guard";
import { EmployeeComponent } from "./components/employee/employee.component";
import { ProgressSpinnerModule } from "primeng/progressspinner";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { LazyLoadScriptService } from "./components/sidebar/lazy-load-script.service";
import { AccountComponent } from "./components/account/account.component";
import { SettingComponent } from "./components/setting/settings.component";
import { FranchiseComponent } from "./components/franchise/franchise.component";
import { ReportingComponent } from "./components/reporting/reporting.component";
import { OperationsComponent } from "./components/operations/operations.component";
import { PermissionGuard } from "./components/guard/permission.guard";
import { AuthInterceptor } from "./interceptors/auth.interceptor";

import { NgIdleKeepaliveModule } from '@ng-idle/keepalive'; // use import { NgIdleModule } from "@ng-idle/core"; if not using keep alive

import { DialogModule } from "primeng/dialog";
import { HomeLayoutComponent } from './layouts/home-layout/home-layout.component';
import { LoginLayoutComponent } from './layouts/login-layout/login-layout.component';
import { ForgotPasswordComponent } from './components/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './components/reset-password/reset-password.component';
import { PasswordModule } from "primeng/password";
import { DragDropModule } from "@angular/cdk/drag-drop";
import { DropdownModule } from 'primeng/dropdown';
import { CalendarModule } from 'primeng/calendar';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { UniversalNoteComponent } from './components/universal-note/universal-note.component';

import { APP_INITIALIZER, ErrorHandler } from '@angular/core';
import { Router } from '@angular/router';
import * as Sentry from "@sentry/angular";

import { MyPermissionService } from './services/my-permission.service';
export function initPermissions(permissionService: MyPermissionService) {
  return () => {
    return permissionService.loadPermissions()
      .catch((err) => {
        console.error('Permission loading failed:', err);
        return Promise.resolve();
      });
  };
}
@NgModule({
  declarations: [
    AppComponent,
    NotAuthorizedComponent,
    HeaderComponent,
    SidebarComponent,
    LoginComponent,
    HomeComponent,
    LeadsComponent,
    ClientComponent,
    EmployeeComponent,
    AccountComponent,
    SettingComponent,
    FranchiseComponent,
    OperationsComponent,
    ReportingComponent,
    TrainingComponent,
    HomeLayoutComponent,
    LoginLayoutComponent,
    ForgotPasswordComponent,
    ResetPasswordComponent,
    removeWhitespacePipe,
    UniversalNoteComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    ButtonModule,
    InputTextModule,
    FormsModule,
    MessagesModule,
    MessageModule,
    HttpClientModule,
    ToastModule,
    ProgressSpinnerModule,
    ConfirmDialogModule,
    NgIdleKeepaliveModule.forRoot(),
    DialogModule,
    PasswordModule,
    DragDropModule,
    DropdownModule,
    CalendarModule,
    InputTextareaModule,
  ],
  providers: [
    LoginService,
    AuthGuard,
    SecureInnerPagesGuard,
    LazyLoadScriptService,
    PermissionGuard,
    provideAuth0({
      domain: 'ifast-dev.us.auth0.com',
      clientId: 'hWzpnVR6rtZO6B9gNJpDyl19cyi8jrv0',
      authorizationParams: {
        audience: 'ifast-dev',
        redirect_uri: window.location.origin
      }
    }),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },{
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler(),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => {},
      deps: [Sentry.TraceService],
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initPermissions,
      deps: [MyPermissionService],
      multi: true
    }
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
